/**
 * MATCH REPORTS interfaces and types
 */
import { IMatch } from './match';

export type ReportStatus = 'Published' | null;

const MATCH_REPORT_STATUS_PUBLISHED: ReportStatus = 'Published';
const MatchReportStatusList: ReportStatus[] = [MATCH_REPORT_STATUS_PUBLISHED, null];
export interface IMatchReport extends IMatch {
  reportStatus?: ReportStatus;
  reportUrl?: string;
}
export interface ILmpResultsMatch extends IMatchReport {
  roundName?: string;
}

export interface IReportsHomeMatch extends IMatchReport {}

export interface IReportsDetailsMatch extends IMatchReport {}

export { MATCH_REPORT_STATUS_PUBLISHED, MatchReportStatusList };
